/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The LoyaltyTerminologyModel model module.
* @module model/LoyaltyTerminologyModel
* @version 1.0.0
*/
export default class LoyaltyTerminologyModel {
    /**
    * Constructs a new <code>LoyaltyTerminologyModel</code>.
    * @alias module:model/LoyaltyTerminologyModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>LoyaltyTerminologyModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/LoyaltyTerminologyModel} obj Optional instance to populate.
    * @return {module:model/LoyaltyTerminologyModel} The populated <code>LoyaltyTerminologyModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LoyaltyTerminologyModel();
                        
            
            if (data.hasOwnProperty('One')) {
                obj['One'] = ApiClient.convertToType(data['One'], 'String');
            }
            if (data.hasOwnProperty('Other')) {
                obj['Other'] = ApiClient.convertToType(data['Other'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {String} One
    */
    'One' = undefined;
    /**
    * @member {String} Other
    */
    'Other' = undefined;




}
